export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Apply Your Code',
      description: 'Copy the RAMESCO promo code and paste it during checkout to instantly unlock your 55% discount on any challenge size.',
      icon: 'ri-coupon-3-line',
      image: 'https://public.readdy.ai/ai/img_res/956a245c5a25c6fa1b756ecc34e3c94f.jpg'
    },
    {
      number: '02',
      title: 'Choose Your Challenge',
      description: 'Select from $10K to $200K funding options. Pick the challenge that matches your trading style and experience level.',
      icon: 'ri-bar-chart-box-line',
      image: 'https://readdy.ai/api/search-image?query=clean%20modern%20illustration%20showing%20multiple%20trading%20account%20tiers%20from%20small%20to%20large%20with%20upward%20growth%20arrows%2C%20minimalist%20design%20with%20cyan%20and%20blue%20gradient%20colors%2C%20simple%20white%20background%2C%20professional%20financial%20concept%20art&width=400&height=300&seq=challenge-selection-qt&orientation=landscape'
    },
    {
      number: '03',
      title: 'Start Trading & Get Paid',
      description: 'Pass your challenge, receive your funded account, and start earning up to 90% profit splits with fast, reliable payouts.',
      icon: 'ri-money-dollar-circle-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20illustration%20of%20successful%20trader%20celebrating%20with%20money%20symbols%20and%20upward%20trending%20charts%2C%20clean%20design%20with%20cyan%20and%20blue%20colors%2C%20simple%20background%2C%20professional%20digital%20art%20style%20showing%20financial%20success&width=400&height=300&seq=trading-success-qt&orientation=landscape'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-black text-gray-900 mb-4">
            Get Funded in 3 Simple Steps
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Start trading with up to $200,000 in capital and keep up to 90% of your profits
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-cyan-500 via-blue-500 to-purple-600 transform -translate-x-1/2"></div>

          {/* Steps */}
          <div className="space-y-24">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`relative flex flex-col lg:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Content Side */}
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                  <div className="inline-block px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold rounded-full mb-4">
                    Step {step.number}
                  </div>
                  <h3 className="text-3xl font-black text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-lg text-gray-600 leading-relaxed max-w-md mx-auto lg:mx-0">
                    {step.description}
                  </p>
                </div>

                {/* Center Node */}
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-20 h-20 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg shadow-cyan-500/50">
                    <i className={`${step.icon} text-4xl text-white`}></i>
                  </div>
                </div>

                {/* Image Side */}
                <div className="flex-1">
                  <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-gray-100 hover:border-cyan-500/50 transition-all duration-300">
                    <div className="w-full h-72">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-20 text-center">
          <a
            href="https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-xl font-bold rounded-full hover:shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Start Your Journey Now
            <i className="ri-arrow-right-line text-2xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
